<template>
  <div v-if="!hidden">
    <section-title content="Información de Dirección Física" :has-line="true" />
    <div class="rounded pt-2 pb-3 px-4">
      <div class="row">
        <div class="col-md-4">
          <label class="data-title mb-0">Tipo de Dirección:</label>
          <custom-drop-down
            :clearable="false"
            :disabled="true"
            fieldkey="id"
            fieldname="name"
            :options="addressTypeOptions"
            :value="addressType"
          />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="addressLine1"
            rules="required"
          >
            <label class="data-title mb-0">Dirección (Línea 1):</label>
            <custom-input
              v-model="model.addressLine1"
              :custom-error-msg="'La dirección (línea 1) es requerida.'"
              :error="errors[0]"
            />
          </validation-provider>
        </div>

        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="addressMunicipality"
            rules="required"
          >
            <label class="data-title mb-0">Municipio:</label>
            <custom-drop-down
              v-model="municipalitySelected"
              custom-error-msg="El municipio es requerido."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              :options="municipalities"
              placeholder="Seleccione"
              @input="onChangeMunicipality"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider
            v-slot="{ errors }"
            name="addressPostalCode"
            rules="required"
          >
            <label class="data-title mb-0">Código Postal:</label>
            <custom-input
              v-model="model.zipCode"
              :custom-error-msg="'El código postal es requerido.'"
              :error="errors[0]"
              mask-type="ZipcodeExt"
              placeholder="#####-####"
            />
          </validation-provider>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <label class="data-title mb-0">Dirección (Línea 2):</label>
          <custom-input v-model="model.addressLine2" />
        </div>

        <div class="col-md-4">
          <label class="data-title mb-0">Latitud:</label>
          <custom-input v-model.number="model.latitude" type="number" />
        </div>
        <div class="col-md-4">
          <label class="data-title mb-0">Longitud:</label>
          <custom-input v-model.number="model.longitude" type="number" />
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-4">
          <label class="data-title mb-0">Dirección (Línea 3):</label>
          <custom-input v-model="model.addressLine3" />
        </div>
        <div class="col-md-8">
          <label class="data-title mb-0">Anotaciones Adicionales:</label>
          <custom-input
            v-model="model.additionalAnnotations"
            placeholder="Escribir información adicional de como llegar..."
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import AddressTypes from '@/utils/constants/addressTypes.js';
export default {
  name: 'PhysicalAddressInfo',
  components: {
    ValidationProvider,
    SectionTitle,
    CustomDropDown,
    CustomInput,
  },
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    municipalities: {
      type: Array,
      default: () => [],
    },
    addressTypes: {
      type: Array,
      default: () => [],
    },
    hidden: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      municipalitySelected: null,
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    addressTypeOptions() {
      return [...this.addressTypes].filter(
        (x) => x.id === AddressTypes.Physical
      );
    },
    addressType() {
      return this.addressTypeOptions[0];
    },
  },
  methods: {
    onChangeMunicipality(item) {
      this.model.municipalityId = item?.id;
    },
  },
  watch: {
    'model.municipalityId': function(value) {
      if (this.municipalitySelected) return;
      if (!value) {
        this.municipalitySelected = null;
        return;
      }

      this.municipalitySelected = this.municipalities.find(
        (y) => y.id === value
      );
    },
  },
};
</script>

<style scoped lang="scss"></style>
